import PageAvatarInfo from "../../Avatar/PageAvatarInfo/PageAvatarInfo";
import classes from "../CustomInputs.module.css";
import { Button } from "@mui/material";
import Strings from "../../../../resources/Strings";
import { getBase64 } from "../../../../utils/CommonUtils";

const UploadImageInput = (props) => {
  const handleFileChange = (event) => {
    const { name } = event.target;
    const newImage = event.target?.files?.[0];

    if (newImage) {
      getBase64(newImage, (result) => {
        props.onChange({[name]: result });
      });
    }
  };
  return (
    <div className={classes.uploadImageInput}>
      <PageAvatarInfo alt="Avatar" image={props.image} />
      <input
        accept="image/*"
        hidden
        id={props.id}
        name={props.id}
        type="file"
        onChange={handleFileChange}
      />
      <label htmlFor={props.id} className={classes.action}>
        <Button className={classes.formButton} component="span">
        {Strings.INPUT_LABELS.UPLOAD_PROFILE_IMAGE}
        </Button>
      </label>
    </div>
  );
};

export default UploadImageInput;
